var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLkqlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 16,
    viewBox: "0 0 59 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.3506V1.05664H6.4572V9.8437H14.3376V14.3479H0V14.3506Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7482 14.3506H28.7729L22.7321 7.76158V14.3506H16.2749V1.05664H22.7321V7.01308L28.5647 1.05664H36.4266L29.3422 7.38206L36.7482 14.3506Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2307 15.4705H50.975L49.3936 14.0077C48.4237 14.519 46.5814 14.8827 44.7787 14.8827C38.7406 14.8827 35.1509 12.1628 35.1509 7.58214C35.1535 3.16489 39.1043 0.529297 45.7697 0.529297C52.3587 0.529297 56.2725 3.16489 56.2725 7.60059C56.2783 8.41384 56.1237 9.22026 55.8176 9.9737C55.5114 10.7271 55.0597 11.4128 54.4882 11.9915L58.2307 15.4705ZM45.6379 10.7264C48.3157 10.7264 49.7204 9.67216 49.7204 7.68492C49.7204 5.69769 48.3367 4.66454 45.6959 4.66454C43.055 4.66454 41.6898 5.71877 41.6898 7.74291C41.6871 9.71169 43.055 10.7369 45.6379 10.7369V10.7264Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLkqlogo);
export default __webpack_public_path__ + "static/media/lkq.logo.67fff3665f679ed68375807cc8c65de3.svg";
export { ForwardRef as ReactComponent };